import React, { useState } from 'react';
import styled from 'styled-components';

const Error = () => {
  return (
    <Wraper>
      <div>
        <div style={{ textAlign: 'center', margin: '48px auto 0' }}>
          <img className="titleImg" src="https://hk-web.apaylater.net/atome.svg" alt="Atome" />
        </div>
      </div>
      <div className="success_wraper">
        <p className="success_wraper_ok">✓</p>
        <p className="success_wraper_tip1">Thank you</p>
        <p className="success_wraper_tip2">The form was submitted successfully. </p>
        <p className="success_wraper_content">
          We would notify you on the application result in <b>three to five working days</b> and guide you how to
          complete the onboarding.
        </p>
        <p className="success_wraper_content">Looking forward to having you in Atome Platform.</p>
      </div>
    </Wraper>
  );
};

const Wraper = styled.div`
  overflow: hidden;
  .success_wraper {
    text-align: center;
    &_ok {
      width: 70px;
      height: 70px;
      color: #fff;
      background-color: #b9e1bd;
      border: 1px solid #69a47e;
      font-size: 35px;
      border-radius: 50%;
      line-height: 65px;
      text-align: center;
      margin: 0 auto;
    }
    &_tip1 {
      font-size: 24px;
      font-weight: 600;
      padding-top: 9px;
      padding-bottom: 13px;
      margin-bottom: 0;
    }
    &_tip2 {
      font-size: 20px;
      font-weight: 600;
      padding-bottom: 13px;
    }
    &_content {
      width: 328px;
      font-size: 14px;
      padding-bottom: 13px;
      margin: 0 auto;
    }
  }
`;

export default Error;
